function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.54428,
  cy: 11.5482,
  rx: 1.45523,
  ry: 1.45185,
  transform: "rotate(-180 1.54428 11.5482)"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.54477,
  cy: 6.50056,
  rx: 1.45523,
  ry: 1.45185,
  transform: "rotate(-180 1.54477 6.50056)"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.54477,
  cy: 1.45186,
  rx: 1.45523,
  ry: 1.45187,
  transform: "rotate(-180 1.54477 1.45186)"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 3,
  height: 13,
  viewBox: "0 0 3 13"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/dots.02fe384a.svg";
export { SvgComponent as ReactComponent };